import type { IconData } from '@stacksjs/iconify-core'

export const transportationTruck: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 12.19h-1.52v-1.53h-1.52V9.14H25.9v3.05h-1.52v1.52h-1.52V9.14h3.04V7.62h-7.62V6.09h-1.52v10.67H1.52V6.09H0v16.76h1.52v-4.57h15.24v4.57h-6.1v-1.52H9.14v4.57h1.52v-1.52h9.15v1.52h1.52v-4.57h-1.52v1.52h-1.53V9.14h3.05v6.1h1.53v1.52h7.61v6.09H32v-9.14h-1.53z\"/><path fill=\"currentColor\" d=\"M27.43 21.33H25.9v4.57h1.53v-1.52h3.04v-1.53h-3.04zm-6.1 4.57h4.57v1.53h-4.57Zm1.53-3.05h1.52v1.53h-1.52Zm-1.53-3.04h4.57v1.52h-4.57Zm-16.76 0h4.57v1.52H4.57Zm0 6.09h4.57v1.53H4.57Zm1.52-3.05h1.53v1.53H6.09ZM3.05 12.19h12.19v1.52H3.05Zm0-3.05h12.19v1.52H3.05Zm1.52 12.19H3.05v1.52H1.52v1.53h1.53v1.52h1.52zM1.52 4.57h15.24v1.52H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default transportationTruck
